import { Card, Grid, Text, Toggle, Loader } from "@certn/cascadia-react";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { useRestrictApplicantCommunications } from "./useRestrictApplicantCommunications";
import { css } from "@emotion/css";
import { Stack } from "@certn/cascadia";

export function GroupPreferencesTab() {
  const { groupId } = useParams();
  const { data, isLoading, updating, updateRestrictApplicantCommunications } =
    useRestrictApplicantCommunications(groupId);

  if (!data) {
    if (isLoading) {
      return <Loader overlay />;
    }

    return (
      <Card className={styles.groupPreferencesCard}>
        <Text style="global/body-secondary">
          {t("Unable to load group preferences. Please try again later.")}
        </Text>
      </Card>
    );
  }
  return (
    <Card className={styles.groupPreferencesCard}>
      <Grid form>
        <Text style="form/section-heading">
          {t("Applicant Visibility & Notifications")}
        </Text>
        <Stack gap="space-2" orientation="horizontal" align="start">
          <Toggle
            testID="applicant-visibility-toggle"
            id="applicant-visibility-toggle"
            aria-label="toggle applicant visibility"
            isSelected={data?.restrict_applicant_communications}
            onChange={(value) => updateRestrictApplicantCommunications(value)}
            isDisabled={updating}
          />
          <Stack gap="space-1">
            <Text style="input/label" color="text-weak">
              {t("Restrict applicant communications and report access")}
            </Text>
            <Text style="input/helper" color="text-weak">
              {t(
                "When enabled, applicants can only submit the information needed to complete checks. They will not receive case status updates, completion notifications, or access to final reports."
              )}
            </Text>
          </Stack>
        </Stack>
      </Grid>
    </Card>
  );
}

const styles = {
  groupPreferencesCard: css({
    padding: "var(--space-5)",
    borderRadius: "var(--border-radius-3)",
  }),
};
